module.exports = __webpack_public_path__ + "img/rectangle_outlines.aab2d4a2.svg";